import axios from 'axios';

export interface TransactionStats {
  totalTransactions: number;
  totalCompleted: number;
  totalPending: number;
  totalAmount: number;
}

export interface TransactionFilters {
  page?: number;
  limit?: number;
  type?: UnifiedTransactionType;
  status?: TransactionStatus;
  search?: string;
  startDate?: string;
  endDate?: string;
}

export interface PaginatedTransactionsResponse {
  transactions: Transaction[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

/**
 * Get transaction statistics combining credit and crypto transactions
 */
export const getTransactionStatsApi = async (): Promise<TransactionStats> => {
  const response = await axios.get<{
    success: boolean;
    data: TransactionStats;
  }>('/api/transactions/stats');
  return response.data.data;
};

/**
 * Get combined transactions with filtering and pagination
 */
export const getTransactionsApi = async (
  filters?: TransactionFilters,
): Promise<PaginatedTransactionsResponse> => {
  const params = new URLSearchParams();
  if (filters?.page) params.set('page', filters.page.toString());
  if (filters?.limit) params.set('limit', filters.limit.toString());
  if (filters?.type) params.set('type', filters.type);
  if (filters?.status) params.set('status', filters.status);
  if (filters?.search) params.set('search', filters.search);
  if (filters?.startDate) params.set('startDate', filters.startDate);
  if (filters?.endDate) params.set('endDate', filters.endDate);

  const response = await axios.get<{
    success: boolean;
    data: Transaction[];
    pagination: PaginatedTransactionsResponse['pagination'];
  }>(`/api/transactions?${params.toString()}`);
  return {
    transactions: response.data.data,
    pagination: response.data.pagination,
  };
};

/**
 * Get a single transaction by ID
 */
export const getTransactionByIdApi = async (
  transactionId: string,
): Promise<Transaction> => {
  const response = await axios.get<{
    success: boolean;
    data: Transaction;
  }>(`/api/transactions/${transactionId}`);
  return response.data.data;
};
